import WithAuth from './WithAuth'

export default WithAuth
// eslint-disable-next-line import/export
export * from './WithAuth'
